module.exports = __webpack_public_path__ + "static/media/pencil-paintbrush.12ac04ad.svg";